var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.45 16.4712L10.725 11.7462C10.35 12.0462 9.91875 12.2837 9.43125 12.4587C8.94375 12.6337 8.425 12.7212 7.875 12.7212C6.5125 12.7212 5.3595 12.2492 4.416 11.3052C3.4725 10.3612 3.0005 9.20819 3 7.84619C3 6.48369 3.472 5.33069 4.416 4.38719C5.36 3.44369 6.513 2.97169 7.875 2.97119C9.2375 2.97119 10.3905 3.44319 11.334 4.38719C12.2775 5.33119 12.7495 6.48419 12.75 7.84619C12.75 8.39619 12.6625 8.91494 12.4875 9.40244C12.3125 9.88994 12.075 10.3212 11.775 10.6962L16.5 15.4212L15.45 16.4712ZM7.875 11.2212C8.8125 11.2212 9.6095 10.8929 10.266 10.2364C10.9225 9.57994 11.2505 8.78319 11.25 7.84619C11.25 6.90869 10.9218 6.11169 10.2653 5.45519C9.60875 4.79869 8.812 4.47069 7.875 4.47119C6.9375 4.47119 6.1405 4.79944 5.484 5.45594C4.8275 6.11244 4.4995 6.90919 4.5 7.84619C4.5 8.78369 4.82825 9.58069 5.48475 10.2372C6.14125 10.8937 6.938 11.2217 7.875 11.2212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.7eb130ccadf4652486e9238b0b8633da.svg";
export { ForwardRef as ReactComponent };